import React from "react";
import styled from "styled-components";
import img from "../assets/images/homepage/Best-Pharmacy-websites-in-UK-removebg-preview.png";
import About from "../containers/About";
import Categories from "../containers/Categories";
import ContactUs from "../containers/ContactUs";
import Card from "../containers/Card";
import Team from "../containers/Team/Team"
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const Home = () => {

  const particlesInit = async (main) => {
    console.log(main);

    await loadFull(main);
  };

  return (
    <Container>
        <Particles
      id="tsparticles"
      init={particlesInit}

      options={{
        "fullScreen": {
            "enable": true,
            "zIndex": -11
        },
        "particles": {
          "number": {
            "value": 20,
            "density": {
              "enable": true,
              "value_area": 800
            }
          },
          "color": {
            "value": "#ff3946",
          },
          "shape": {
            "type": "circle",
            "stroke": {
              "width": 0,
              "color": "#ff3946"
            },
            "polygon": {
              "nb_sides": 5
            },
            "image": {
              "src": "img/github.svg",
              "width": 100,
              "height": 100
            }
          },
          "opacity": {
            "value": 0.5,
            "random": false,
            "anim": {
              "enable": false,
              "speed": 0.5,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": 10,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 80,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": true,
            "distance": 300,
            "color": "#314584",
            "opacity": 0.4,
            "width": 2
          },
          "move": {
            "enable": true,
            "speed": 12,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": false,
              "mode": "repulse"
            },
            "onclick": {
              "enable": true,
              "mode": "push"
            },
            "resize": true
          },
          "modes": {
            "grab": {
              "distance": 800,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 800,
              "size": 80,
              "duration": 2,
              "opacity": 0.8,
              "speed": 3
            },
            "repulse": {
              "distance": 400,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true,
      }
    }
    />
      <HeaderContainer>
        <ContainerInner>
          <MainTitle>The Spirit of Community Pharmacy.</MainTitle>
          <MainSubTitle>
            
We accept that everybody merits admittance to reasonable meds, consequently, through a solid obligation to our patients and solid associations with drug organizations, we are capable give minimal expense prescriptions to the individuals who need them most.
<br />
          </MainSubTitle>
          <br /><br />
          <BtnContainer>
            <BtnPrimary>More About Us</BtnPrimary>
            {/* <BtnSecondary>Get in Touch</BtnSecondary> */}
          </BtnContainer>
          <BGText>Pharmacy</BGText>
        </ContainerInner>
        <ContainerInner>
          <MainImg src={img} alt="pharmacy" />
        </ContainerInner>
      </HeaderContainer>

      <Categories/>
      <About/>
      <Team/>

      <Card/>
      <ContactUs />
      
    </Container>
  );
};

export default Home;



const BGText = styled.span`
  color: var(--color-red);
  font-weight: 600;
  opacity: 0.1;
  font-size: 10rem;
  transform: translateY(-4rem) translateX(3rem);
  position: absolute;
`;

const MainImg = styled.img`
  transform: scale(1.4) translateX(2rem);
  opacity: 0.8;
  /* position: absolute; */
`;

// const BtnSecondary = styled.button`
//   color: var(--color-blue);
//   padding: 1rem 3rem;
//   border-radius: 3rem;
//   font-size: 1rem;
//   font-weight: bold;
//   letter-spacing: 1.5px;
//   border: none;
//   background: white;
// `;

const BtnPrimary = styled.button`
  border: none;
  font-weight: bold;
  letter-spacing: 1.5px;
  font-size: 1rem;
  color: white;
  background: var(--color-red);
  padding: 1rem 3rem;
  border-radius: 3rem;

  &:hover {
    color: var(--color-red);
    background: white;
    outline: 2px solid var(--color-red);
  }
`;

const BtnContainer = styled.div``;

const MainTitle = styled.h1`
  color: var(--color-blue);
  font-size: 3rem;
  letter-spacing: 2px;
`;

const MainSubTitle = styled.h5`
  font-size: 1.3rem;
  opacity: 0.5;
  letter-spacing: 1.5px;
  text-align: justify;
`;

const Container = styled.div``;

const HeaderContainer = styled.div`
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* padding: 2rem 10rem; */
  padding-top: 5rem;
  padding-bottom: 5rem;
  max-width: 1300px;
  margin: auto;
`;

const ContainerInner = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  margin-bottom: 2rem;
`;
